import React from 'react';

export const SpaContext = React.createContext({});
